import NextLink from "next/link";

import type { BlogPostProps } from "~/types";
import { CurveBanner, Title, Wrapper, HeroText } from "~/ui";
import { CursiveBasic } from "~/ui/cursive-basic";
import { BlogCard } from "./blog-card";
import { useState } from "react";
import { ViewMore } from "../common";

export const BlogContent = ({
  articles,
  totalPages,
  totalPosts,
}: BlogPostProps) => {
  const [blogPosts, setblogPosts] = useState(articles);
  const [page, setpage] = useState(1);

  const fetchMorePosts = async () => {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/blogs?page=${page + 1}`
    );
    const data = await response.json();

    setblogPosts((prev: any) => [...prev, ...data.blogs]);
    setpage(page + 1);
  };

  return (
    <div className="h-full w-full bg-colorSixteen">
      <CurveBanner>
        <div className="container mx-auto">
          <h1 className="font-tucker-tub text-4xl font-bold uppercase text-colorFourteen lg:text-header">
            Blog
          </h1>
        </div>
      </CurveBanner>
      <Wrapper>
        <div className="h-[200px]" />
        <div className="py-20">
          <Title className="text-colorFourteen">Tucker Tub Blogs</Title>
          <CursiveBasic className=" text-gray-50">
            Resources from our team of canine experts
          </CursiveBasic>
          <div className="py-5 font-haboro-soft text-colorFourteen">
            <HeroText>
              We all want our pups to lead long, healthy lives. That's why we
              can't ignore their nutrition. Gut health plays a vital role in
              your dog's overall wellbeing, from the shine of their coat to
              their mood. Pups with a balanced diet enjoy a healthier
              microbiome, good digestion, a stronger immune system and other
              benefits. By being mindful about what our pets eat, we can help
              them live their happiest lives.
            </HeroText>
            <br />
            <HeroText>
              These articles offer feeding guides and nutrition advice, plus the
              latest findings in pet gut health.
            </HeroText>
            <br />
            <HeroText>
              Ready to take your dog parenting skills a step further? Hear
              directly from the experts. Our team has over 25 years of expertise
              when it comes to dog nutrition. The best way to get started on
              Tucker Tub is to{" "}
              <NextLink href="/consultation" className="font-medium underline">
                book a free consultation
              </NextLink>{" "}
              with our pet nutritionists.
            </HeroText>
          </div>
        </div>
      </Wrapper>
      <div className="container p-0">
        <div>
          {blogPosts.length > 0 && (
            <section className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 mx-3">
              {blogPosts.map((d: any) => (
                <BlogCard key={d.id} {...d} />
              ))}
            </section>
          )}
          {blogPosts.length === 0 && (
            <div className="text-center w-full">
              <Title className="text-colorFourteen">
                No Blogs available as of now
              </Title>
            </div>
          )}
        </div>
        {totalPages > page && (
          <div className="mt-4">
            <ViewMore
              dataLength={totalPosts}
              maxItemsLength={page * 10}
              handleViewMoreClick={fetchMorePosts}
              buttonVariant="tertiary"
            />
          </div>
        )}
      </div>
    </div>
  );
};
